import { Action, Module, VuexModule } from "vuex-module-decorators";
import { Speaker } from "@/store/enums/StoreEnums";
import ApiService from "@/core/services/ApiService";
import { CookieComponent } from "@/assets/ts/components";

@Module
export default class SpeakerModule extends VuexModule {
    @Action
    [Speaker.getSpeakerList]() {
        return new Promise<void>((resolve, reject) => {
            ApiService.get(`/speakers/list`)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [Speaker.findPageSpeaker](values) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/speakers`,values)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [Speaker.saveSpeaker](values) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/speakers/save`, values)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [Speaker.deleteSpeaker](values) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/speakers/delete`, values)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

}